<div *ngIf="!cards" class="alc-spinner-wrapper-in-flow alc-progress-container">
  <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div [hidden]="!cards">
  <form [formGroup]="form" class="overview-form">
    <app-select
      [control]="form.controls.timeIntervalType"
      [items]="predefinedIntervals"
      [localStorageKey]="dashboardTimeIntervalLocalStorageKey">
    </app-select>

    <app-select
      [control]="form.controls.routingTags"
      [items]="routingTagItems"
      [label]="routingTagLabel"
      [multiple]="true"
      [localStorageKey]="routingTagsLocalStorageKey">
    </app-select>
  </form>
  <div class="dashboard-cards">
    <app-dashboard-card *ngFor="let card of cards" [card]="card"></app-dashboard-card>
  </div>
</div>
